export const MOCK_ENDPOINTS = ['getSharedProfiles'];